import PropTypes from 'prop-types';
import { ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import { useFinancialYear } from '../../hooks/useFinancialYear';
import { EX_SUMMARY_VIEW } from '../Constants/Constants';
import { toLocalDate } from '../Utils/Helper';

const SummaryViewToggleButton = ({ handleViewChange, activeView }) => {
  const { isCurrentFinancialYear, selectedFinancialYear } = useFinancialYear();

  if (!isCurrentFinancialYear) {
    return null;
  }

  return (
    <ToggleButtonGroup
      className="view-toggle"
      name="execution_view"
      as="div"
      value={activeView}
      type="radio"
      onChange={handleViewChange}>
      <ToggleButton
        size="sm"
        key={EX_SUMMARY_VIEW.FY}
        id={EX_SUMMARY_VIEW.FY}
        variant={activeView === EX_SUMMARY_VIEW.FY ? 'outline-primary' : 'secondary'}
        value={EX_SUMMARY_VIEW.FY}>
        FY{' '}
        {`${toLocalDate(selectedFinancialYear?.fromDate, 'YYYY')}-${toLocalDate(
          selectedFinancialYear?.toDate,
          'YYYY'
        )}`}
      </ToggleButton>
      <ToggleButton
        size="sm"
        key={EX_SUMMARY_VIEW.TILL_MONTH}
        id={EX_SUMMARY_VIEW.TILL_MONTH}
        variant={activeView === EX_SUMMARY_VIEW.TILL_MONTH ? 'outline-primary' : 'secondary'}
        value={EX_SUMMARY_VIEW.TILL_MONTH}>
        Year-To-Month
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

SummaryViewToggleButton.propTypes = {
  handleViewChange: PropTypes.func.isRequired,
  activeView: PropTypes.string.isRequired,
};

export default SummaryViewToggleButton;
